import { project } from '../types';
import { validateStringValue } from '../utils/common';

const INITIAL_STATE = {
    error: undefined,
    projectList: [],
    allProjectList: [],
    showAddProject: false,
    mainDiv: '',
    projectTeamLists: [],
    projectPosts: {},
    projectFilterData: {},
    projectPMs: {},
    projectsSlas: {},
    projectListData: null,
    contactPersonDetails: [],
    projectDropdownListData: [],
    projectTeamsData: {},
    managers: [],
    projectDetailsData: {},
    eligiblePms: [],
    milestones: [],
    milestonesDropdown: [],
    preCreatedProjectId: null,
    projectFilterPayload: {},
    // Auto Accept — paginated project list (server-side search + infinite scroll).
    autoAcceptProjectList: [],
    autoAcceptProjectListPage: 1,
    autoAcceptProjectListHasMore: false,
};

const projectReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // case project.GET_PROJECT_LIST_SUCCESS:
        //     return {
        //         ...state,
        //         projectList: action.payload,
        //     };
        case project.GET_ALL_PROJECT_DROPDOWN_LIST_SUCCESS:
            return {
                ...state,
                projectDropdownList: action.payload,
            };

        case project.PROJECTS_COUNT_SUCCESS:
            return {
                ...state,
                projectListCount: action.payload,
            };
        case project.CREATR_PROJECT_TEMPLATE_SUCCESS:
            const { data } = action.payload
            return {
                ...state,
                newTemplateData: { key: Math.random(), value: data.id, label: data.title },
            };
        case project.UPDATE_PM_DETAILS_FAILURE:
            // case project.GET_PROJECT_LIST_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case project.GET_PROJECT_POST_LIST_SUCCESS: {
            const { projectId, postList } = action.payload;
            return {
                ...state,
                projectPosts: { ...state.projectPosts, [projectId]: postList },
            };
        }
        case project.CREATE_PROJECT_ATTACHMENT_POST_SUCCESS:
        case project.CREATE_PROJECT_TEXT_POST_SUCCESS: {
            const { projectId, data } = action.payload;

            let list = state.projectPosts;
            if (list[projectId]) {
                list[projectId].unshift(data);
            } else {
                list[projectId] = [data];
            }

            return {
                ...state,
                projectPosts: list,
            };
        }

        case project.PROJECT_POST_STATUS_SUCCESS: {
            const { status, projectId, postId } = action.payload;
            let posts = state.projectPosts;

            posts[projectId] = posts[projectId].map((post) => {
                if (post._id === postId) {
                    return { ...post, status };
                }
                return post;
            });

            return {
                ...state,
                projectPosts: posts,
            };
        }
        case project.GET_PROJECT_POST_LIST_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case project.PROJECT_PREQUISITE_LIST_SUCCESS:
            return {
                ...state,
                sitePreRequisite: action.payload.sitePreRequisite,
            };

        case project.SHOW_TEMPLATE_LIST_SUCCESS:
            return {
                ...state,
                templates: action.payload,
            };

        case project.PROJECT_TEAM_LIST_SUCCESS:
            return {
                ...state,
                projectTeamLists: action.payload.data,
            };

        case project.IS_SHOW_ADD_PROJECT:
            const { showProjectDetails, mainDiv, isOpen } = action.payload;
            return {
                ...state,
                isToShowAddProject: isOpen,
                mainDiv: mainDiv,
                showProjectDetails: showProjectDetails,
            };

        case project.GET_SCOGO_DEALIDS_DROPDOWN_SUCCESS:
            const { list } = action.payload;
            return {
                ...state,
                dealList: list,
            };
        case project.CLEAR_DEAL_DROPDOWN_LIST_FROM_STORE:
            return {
                ...state,
                dealList: undefined,
            };

        case project.EDIT_PROJECT_SUCCESS: {
            const { formValues } = action.payload;
            const { project_id } = formValues;
            const findAndUpdate = ({ id, dataList, updatingValues }) => {
                let newList = dataList?.map((item) => {
                    if (item?.id === id) {
                        return Object.assign(item, updatingValues);
                    } else return item;
                });
                return newList;
            };
            const updatedprojectData = findAndUpdate({ id: project_id, dataList: state.projectList, updatingValues: formValues });
            return {
                ...state,
                projectList: updatedprojectData,
            };
        }

        case project.GET_LINKED_PROJECT_OF_USERS_SUCCESS: {
            return {
                ...state,
                linkedUserProjects: action.payload,
            };
        }

        case project.GET_LINKED_PROJECT_OF_TEAMS_SUCCESS: {
            return {
                ...state,
                linkedTeamsProjects: action.payload,
            };
        }
        case project.CREATR_WORKFLOW_SUCCESS: {
            const { projectId, fk_template_id } = action.payload;
            const projectList = state.projectList;
            const findProjectIndex = projectList.findIndex((project) => project.id === projectId);
            if (projectList[findProjectIndex]) {
                projectList[findProjectIndex].fk_template_id = fk_template_id;
            }
            return {
                ...state,
                projectList
            };
        }

        case project.GET_PROJECT_PM_SUCCESS: {
            const { projectId, projectPM } = action.payload
            return {
                ...state,
                projectPMs: {
                    ...state.projectPMs, [projectId]: projectPM
                }
            };
        }
        case project.GET_PROJECTS_SLA_SUCCESS: {
            const { slas, projectId } = action.payload;
            return {
                ...state,
                projectsSlas: {
                    ...state.projectsSlas, [projectId]: slas
                }
            };
        }

        case project.EDIT_PROJECT_PM_SUCCESS: {
            const { projectId, projectPM } = action.payload
            const projectList = state.projectList;
            const index = projectList.findIndex((project) => project.id === projectId);
            const first_pm = projectPM?.find((pm) => pm.order === 1);
            if (projectList[index] && first_pm && first_pm.user) {
                projectList[index].scogo_pm_mobile = first_pm.user.mobile;
                projectList[index].scogo_pm_name = validateStringValue(`${first_pm.user.first_name} ${first_pm.user.last_name}`);
                projectList[index].scogo_pm_id = first_pm.fk_user_id;
            }
            return {
                ...state,
                projectPMs: {
                    ...state.projectPMs, [projectId]: projectPM
                },
                projectList
            };
        }
        case project.SAVE_CONTACT_PERSON_DETAILS: {
            const { formValues } = action.payload;

            return {
                ...state,
                contactPersonDetails: [...state.contactPersonDetails, formValues]
            };
        }
        case project.GET_CONTACT_PERSON_DETAILS_SUCCESS: {
            const payload = action.payload
            return {
                ...state,
                contactPersonDetails: payload.data.data
            }

        }
        case project.GET_PROJECT_DETAIL_SUCCESS: {
            const details = action.payload;

            return {
                ...state,
                projectDetailsData: {
                    ...state.projectDetailsData,
                    [details.id]: details
                }
            }
        }
        case project.GET_PROJECT_ELIGIBLE_PMS_LIST_SUCCESS: {
            const { data } = action.payload;
            let eligiblePms = [...state.eligiblePms, ...data];
            eligiblePms = Array.from(new Map(eligiblePms.map(item => [item.id, item])).values());
            return {
                ...state,
                eligiblePms
            }
        }

        case project.CLEAR_PROJECT_ELIGIBLE_PMS_LIST: {
            return {
                ...state,
                eligiblePms: []
            }
        }
        case project.GET_PROJECT_MANAGER_SUCCESS: {
            const managers = action.payload;
            return {
                ...state,
                managers: managers
            }
        }

        case project.SET_FILTER_PAYLOAD: {
            return {
                ...state,
                projectFilterPayload: action.payload
            }
        }

        case project.CLEAR_PROJECT_DROPDOWN_LIST_DATA: {
            return {
                ...state,
                projectDropdownListData: []
            }
        }
        case project.GET_PROJECT_CHECKLIST_SUCCESS: {
            const { data } = action.payload;
            console.log(data)
            return {
                ...state,
                projectChecklistdata: data
            }
        }

        case project.GET_LINKED_PROJECT_OF_USERS_FAILURE:
        case project.GET_LINKED_PROJECT_OF_TEAMS_FAILURE:
        case project.GET_SCOGO_DEALIDS_DROPDOWN_FAILURE:
        case project.DOWNLOAD_PROJECT_ZIP_FAILURE:
        case project.CREATE_PROJECT_FAILURE:
        case project.SHOW_TEMPLATE_LIST_FAILURE:
        case project.PROJECT_PREQUISITE_LIST_FAILURE:
        case project.EDIT_PROJECT_FAILURE:
        case project.GET_PROJECT_POST_LIST_FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        case project.GET_PROJECTS_LIST_DATA_SUCCESS:
            try {
                const { projectListData = [], page = 1, has_next_page } = action.payload || {};
                let projectListDataList = state.projectListData || [];
                if (page > 1 && Array.isArray(projectListDataList) && Array.isArray(projectListData)) {
                    projectListDataList = [...projectListDataList, ...projectListData];
                } else {
                    projectListDataList = projectListData || [];
                }
                return {
                    ...state,
                    projectListData: projectListDataList,
                    hasProjectListNextPage: has_next_page,
                };

            } catch (error) {
                console.error('Error in GET_PROJECTS_LIST_DATA_SUCCESS:', error);
                return {
                    ...state,
                    projectListData: state.projectListData || [],
                };
            }

        case project.CLEAR_PROJECT_LIST_DATA: {
            return {
                ...state,
                projectListData: []
            }
        }
        case project.GET_AUTO_ACCEPT_PROJECT_LIST_SUCCESS: {
            const { projects, page = 1, append = false, hasMore = false } = action.payload || {};
            const list = Array.isArray(projects) ? projects : [];
            return {
                ...state,
                // Append on "load more"; replace on a fresh category/search load.
                autoAcceptProjectList: append ? [...state.autoAcceptProjectList, ...list] : list,
                autoAcceptProjectListPage: page,
                autoAcceptProjectListHasMore: hasMore,
            };
        }
        case project.GET_AUTO_ACCEPT_PROJECT_LIST_FAILURE: {
            const { append = false } = action.payload || {};
            // On a failed first page, reset to empty so the picker shows "no projects"
            // instead of stale data; a failed "load more" keeps what's already loaded.
            return {
                ...state,
                autoAcceptProjectList: append ? state.autoAcceptProjectList : [],
                autoAcceptProjectListHasMore: false,
            };
        }
        case project.CLEAR_AUTO_ACCEPT_PROJECT_LIST: {
            return {
                ...state,
                autoAcceptProjectList: [],
                autoAcceptProjectListPage: 1,
                autoAcceptProjectListHasMore: false,
            };
        }
        case project.GET_PROJECTS_DROPDOWN_LIST_DATA_SUCCESS: {
            try {
                const { projectListData = [], query } = action.payload || {};
                const list = (query?.length > 0 && Array.isArray(state.projectDropdownListData) && Array.isArray(projectListData))
                    ? [...state.projectDropdownListData, ...projectListData]
                    : projectListData || [];

                const uniqueList = [...new Map(list.map(item => [item.value, item])).values()];

                return {
                    ...state,
                    projectDropdownListData: uniqueList,
                    hasProjectDropdownListNextPage: projectListData.length > 0
                };
            } catch (error) {
                console.error('Error in GET_PROJECTS_DROPDOWN_LIST_DATA_SUCCESS:', error);
                return {
                    ...state,
                    projectDropdownListData: state.projectDropdownListData || []
                };
            }
        }

        case project.GET_TEAM_LIST_OF_PROJECT_SUCCESS: {

            const { projectId, data } = action.payload;
            return {
                ...state,
                projectTeamsData: {
                    ...state.projectTeamsData,
                    [projectId]: data
                }
            }
        };

        case project.UPDATE_PROJECT_POST_SUCCESS: {
            const { projectId, postId, updatedPost } = action.payload;
            return {
                ...state,
                projectPosts: {
                    ...state.projectPosts,
                    [projectId]: state.projectPosts[projectId].map((post) => {
                        if (post.id === postId) {
                            return updatedPost;
                        }
                        return post;
                    })
                }
            }
        }

        case project.REMOVE_TEAM_FROM_PROJECT_SUCCESS: {
            const { projectId, team_ids } = action.payload;
            return {
                ...state,
                projectTeamsData: {
                    ...state.projectTeamsData,
                    [projectId]: state.projectTeamsData[projectId].filter((team) => !team_ids.includes(team.id))
                }
            }
        }

        case project.ADDED_PROJECT_TEAM_USERS_SUCCESS: {
            const { addedMembers, teamId, projectId } = action.payload;
            return {
                ...state,
                projectTeamsData: {
                    ...state.projectTeamsData,
                    [projectId]: state.projectTeamsData[projectId].map((team) => {
                        const newmembers = addedMembers.map((member) => {
                            return {
                                id: member.value,
                                display_name: member.label
                            }
                        })
                        if (team.id === teamId) {
                            return { ...team, members: [...team.members, ...newmembers] };
                        }
                        return team;
                    })
                }
            }
        }

        case project.REMOVE_PROJECT_TEAM_USERS_SUCCESS: {
            const { removedMembers, teamId, projectId } = action.payload;
            return {
                ...state,
                projectTeamsData: {
                    ...state.projectTeamsData,
                    [projectId]: state.projectTeamsData[projectId].map((team) => {
                        if (team.id === teamId) {
                            return { ...team, members: team.members.filter((member) => !removedMembers.includes(member.id)) };
                        }
                        return team;
                    })
                }
            }
        }

        case project.UPDATE_PROJECT_SUCCESS: {
            const { projectId, projectForm, source } = action.payload;


            // details update
            const projectDetailsData = {
                ...state.projectDetailsData,
                [projectId]: {
                    ...state.projectDetailsData?.[projectId],
                    ...projectForm
                }
            };

            // list update
            let projectListData = state.projectListData;
            const projectDetailIndex = projectListData.findIndex((project) => project.id === projectId);
            if (projectListData[projectDetailIndex]) {
                projectListData[projectDetailIndex] = { ...projectListData[projectDetailIndex], ...projectForm };
            }

            return {
                ...state,
                projectListData,
                projectDetailsData
            };
        }


        case project.GET_PROJECT_FILTER_LIST_SUCCESS: {
            const projectFilterList = action.payload || {};
            const status = [{ label: 'Active', value: 'ACTIVE' }, { label: 'Inactive', value: 'INACTIVE' }];
            return {
                ...state,
                projectFilterList: {
                    ...projectFilterList,
                    status
                }
            };
        }


        case project.POST_PROJECT_MANAGER_SUCCESS: {
            const { managers, projectId } = action.payload;
            let projectListData = state.projectListData;

            projectListData = projectListData.map((project) => {
                if (project.id === projectId) {
                    let managersList = managers.map((m) => {
                        const f = managers.find((m2) => m2.role === m.role);
                        if (f) {
                            return {
                                role: f.role,
                                full_name: f.user.full_name,
                                id: f.user.id,
                                mobile: f.user.mobile,
                                email: f.user.email
                            }
                        }
                    })
                    project.managers = managersList;
                }
                return project;
            });

            const projectDetailsData = { ...state.projectDetailsData };
            if (projectDetailsData[projectId]) {
                projectDetailsData[projectId] = {
                    ...projectDetailsData[projectId],
                    managers
                };
            }

            return {
                ...state,
                projectListData,
                projectDetailsData
            }
        }

        case project.GET_MILESTONES_SUCCESS: {
            const milestones = action.payload;
            return {
                ...state,
                milestones
            }
        }

        case project.GET_MILESTONES_DROPDOWN_SUCCESS: {
            const data = action.payload;
            const milestonesDropdown = [...state.milestonesDropdown, ...data];
            return {
                ...state,
                milestonesDropdown
            }
        }

        case project.PRE_CREATED_PROJECT_ID: {
            const { projectId } = action.payload;
            return {
                ...state,
                preCreatedProjectId: projectId
            }
        }

        case project.BLACK_LIST_USER_FROM_PROJECT_SUCCESS: {
            const { projectId, user_id, team_id } = action.payload;
            const projectTeamsData = { ...state.projectTeamsData };

            if (projectTeamsData[projectId]) {
                projectTeamsData[projectId] = projectTeamsData[projectId].map((team) => {
                    if (team.id === team_id) {
                        const members = team.members.map((member) => member.id === user_id ? { ...member, isBlacklisted: true } : member);
                        return { ...team, members };
                    }
                    return team;
                })
            }
            return {
                ...state,
                projectTeamsData
            }
        }
        case project.GET_PROJECT_PO_SUCCESS: {
            const payload = action.payload;

            return {
                ...state,
                projectPo: payload
            }
        }
        case project.WHITE_LIST_USER_FROM_PROJECT_SUCCESS: {
            const { projectId, user_id, team_id } = action.payload;
            const projectTeamsData = { ...state.projectTeamsData };

            if (projectTeamsData[projectId]) {
                projectTeamsData[projectId] = projectTeamsData[projectId].map((team) => {
                    if (team.id === team_id) {
                        const members = team.members.map((member) => member.id === user_id ? { ...member, isBlacklisted: false } : member);
                        return { ...team, members };
                    }
                    return team;
                })
            }
            return {
                ...state,
                projectTeamsData
            }
        }

        case project.EDIT_PROJECT_CHECKLIST_SUCCESS: {
            const payload = action.payload;
            return {
                ...state,
                projectChecklistUpdated: true
            }
        }

        case project.UPDATE_PROJECT_DETAIL_SUCCESS: {
            const { projectId, updatedProjectDetail } = action.payload;
            const projectDetailsData = state.projectDetailsData;
            console.log('projectDetailsData:', projectDetailsData)

            if (projectDetailsData[projectId]) {
                projectDetailsData[projectId] = {
                    ...projectDetailsData[projectId],
                    ...updatedProjectDetail
                }
            }
            console.log('projectDetailsData:', projectDetailsData)
            return {
                ...state,
                projectDetailsData
            }
        }

        default:
            return state;
    }
};

export default projectReducer;


export const findMinMax = ({ list, key }) => {
    let min = Infinity;
    let max = -Infinity;
    if (Array.isArray(list)) {
        list.forEach((elem) => {
            let lookFor = elem?.[key];
            if (lookFor > max && !isNaN(lookFor)) {
                max = lookFor;
            } else if (lookFor < min && !isNaN(lookFor)) {
                min = lookFor;
            }
        });
    }
    if (min === Infinity) min = -1;
    if (max === -Infinity) max = Infinity;
    return { min, max };
};
